import {
  ALL_FIELDS_REQUIRED,
  INVALID_PRICE,
  LARGE_EVENT_TYPE_KEY,
  LARGE_EVENT_TYPE_NAME
} from "constants/event-types-responses"

function isInvalidInput(data: App.EventTypesSubmitPayload, type: "create" | "update") {
  const { key, name, product, price } = data

  const priceRegex = /^[0-9]+(\.[0-9]+)?$/

  if (type === "create" && (!key || !name || !product || !price)) return { isInvalid: true, msg: ALL_FIELDS_REQUIRED }
  if (type === "create" && key.length > 40) return { isInvalid: true, msg: LARGE_EVENT_TYPE_KEY }
  if (name.length > 40) return { isInvalid: true, msg: LARGE_EVENT_TYPE_NAME }
  if (!priceRegex.test(price)) return { isInvalid: true, msg: INVALID_PRICE }

  return { isInvalid: false, msg: "" }
}

export default isInvalidInput
